<div class="page-configurator">

   <div class="container">
      <div class="row">
         
         <div class="content">
            <div stickySidebar containerSelector=".content" innerWrapperSelector=".sidebar__inner" topSpacing="27">
               <div class="col-lg-7 sidebar__inner">
                  <div class="image-room">
                     <div class="comodo {{comodo.id}}" *ngFor="let comodo of comodos">
                        <img class="background-image base" [ngClass]="{'selected': comodoOpen === comodo.id}" src="{{caminhoImg+comodo.imagem}}" alt="{{comodo.nome}}">
                        <div class="atributo {{comodo.id}}-{{comodoAtributo.id}}" *ngFor="let comodoAtributo of getComodoAtributosByComodo(comodo.id)">
                           <div class="variacao {{comodo.id}}-{{comodoAtributo.id}}-{{comodoAtributoVariacao.id}}" *ngFor="let comodoAtributoVariacao of getComodoAtributoVariacoesByAtributo(comodoAtributo.id)">
                              <img *ngIf="!comodoAtributoVariacao.nome.includes('Cor Formica')" class="background-image" [ngClass]="{'selected': checkVariation(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id)}" src="{{caminhoImg+comodoAtributoVariacao.imagem}}" alt="{{comodoAtributoVariacao.nome}}">
                              <div *ngIf="comodoAtributoVariacao.imagem && comodoAtributoVariacao.nome.includes('Cor Formica')" class="background-image svg" [ngClass]="{'selected': checkVariation(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id)}" [inlineSVG]="caminhoImg+comodoAtributoVariacao.imagem" [ngStyle]="{color: getColor(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id, 'background')}"></div>
                           </div>
                        </div>
                     </div> 
                  </div>
                  <div class="infos">
                     <div class="description">
                        {{cliente.apartamento?.nome}} - {{getFormattedValue(selectedApartamento?.planta.metragem.valor)}}m²
                     </div>
                     <div class="room-options">
                        <ul>
                           <li [ngClass]="{'selected': comodoOpen === comodo.id}" *ngFor="let comodo of comodos; let i = index">
                              <a href="javascript:void(0)" (click)="openOption(comodo.id)">{{comodo.nome}}</a>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div class="description">
                     <p>As imagens são meramente ilustrativas. O Cliente, ao preencher, os documentos concorda que as opções aqui selecionadas refletem suas opções na personalização de seu imóvel e de que não haverá alterações em suas escolhas até a entrega das chaves. O preenchimento desse documento é obrigatório até 21/02/2024. 
                        Os itens selecionáveis não apresentam custos adicionais para os clientes HALMA 199 (JFC 199 Empreendimento Imobiliario SPE Ltda - CNPJ 41.843.554/0001-38), com exceção dos móveis planejados em marcenaria que devem ser negociados diretamente com a Fábrica de Móveis Florense Ltda, com endereço na Av. Dr. Jesuíno Marcondes Machado 360, Nova Campinas, CEP 13092-108, Campinas, SP ou por contato telefone + 55 (19) 3251-4066</p>
                  </div>
               </div>
            </div>
            <a (click)="displayOptionsMobile()" class="open-options" *ngIf="!optionsMobileEnabled">&#9776;</a>
            <div class="col-lg-5 options-select" [ngClass]="{'open': optionsMobileEnabled}">
               <div class="top">

                  <div class="room-options mobile">
                     <a (click)="hiddenOptionsMobile()" class="close-options" *ngIf="optionsMobileEnabled">x</a>
                     <div [ngStyle]="{'display': comodoOpen === comodo.id ? 'block' : 'none'}" *ngFor="let comodo of comodos; let i = index">
                        <a href="javascript:void(0)" (click)="openOptionMobile(comodos[i-1])"><</a>
                        <a href="javascript:void(0)" (click)="openOptionMobile(comodos[i+1])">></a>
                        <span class="comodo-nome">{{comodo.nome}}</span>
                     </div>
                  </div>
               </div>

               <div class="details">
                  <div class="title">
                     <h1>{{cliente.apartamento?.nome}}</h1>
                  </div>
                  <!--
                  <div class="ap-info">
                     <div class="value">{{selectedApartamento.preco | currency: 'BRL': true}}</div>
                  </div>
                  <div class="ap-info">
                     <div class="title">
                        Valor adicional
                     </div>
                     <div class="value">
                        {{valorBase | currency: 'BRL': true}}
                     </div>
                  </div>
                  <div class="ap-info">
                     <div class="title">
                        Valor do total
                     </div>
                     <div class="value">
                        {{valorTotal | currency: 'BRL': true}}
                     </div>
                  </div>
                  -->
               </div>

               <div class="details middle">
                  <div class="ap-info">
                     <div class="value">{{selectedApartamento?.andar}}º Andar</div>
                  </div>
                  <div class="ap-info">
                     <div class="value">
                        {{selectedApartamento?.planta.nome}}
                     </div>
                  </div>
                  <div class="ap-info">
                     <div class="value">
                        {{getFormattedValue(selectedApartamento?.planta.metragem.valor)}} m²
                     </div>
                  </div>
                  <!--
                  <div class="ap-info">
                     <div class="value">
                        {{selectedApartamento.orientacao}}
                     </div>
                  </div>
                  -->
               </div>

               <div class="options">
                  <accordion [isAnimated]="true">
                     <accordion-group [isOpen]="comodoOpen === comodo.id" heading="{{comodo.nome}}" (click)="accordionOptionClick(comodo.id)" *ngFor="let comodo of comodos; let i = index">
                        <div class="attribute-details" *ngFor="let comodoAtributo of getComodoAtributosByComodo(comodo.id)" [ngStyle]="{ 'display': comodoAtributo.status ? 'block' : 'none' }">
                           <div class="attribute-title">
                              <div class="name">{{comodoAtributo.nome}}</div>
                              <!--
                              <div class="value">+ {{getVariationPrice(comodo.id+'-'+comodoAtributo.id) | currency: 'BRL': true }}</div>
                              -->
                           </div>
                           <div class="attribute-content">
                              <div class="variation" *ngFor="let comodoAtributoVariacao of getComodoAtributoVariacoesByAtributo(comodoAtributo.id)">
                                 <a href="javascript:void(0)" (click)="openVariation(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id+'-'+getColor(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id, 'background'))">
                                    <img *ngIf="!comodoAtributoVariacao.nome.includes('Cor Formica')" [ngClass]="{'selected': checkVariation(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id)}" src="{{caminhoImg+comodoAtributoVariacao.imagemThumbnail}}" alt="{{comodoAtributoVariacao.nome}}" title="{{comodoAtributoVariacao.nome}}">
                                    <img *ngIf="comodoAtributoVariacao.imagem && comodoAtributoVariacao.nome.includes('Cor Formica')" [colorPicker]="getColor(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id, 'background')" [cpAlphaChannel]="'disabled'" [cpPosition]="'top-right'" [style.background]="getColor(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id, 'selector')" (colorPickerChange)="changeVariationColor($event, comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id)" [ngClass]="{'selected': checkVariation(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id)}" />
                                 </a>
                                 <div class="description" [ngClass]="{'selected': checkVariation(comodo.id+'-'+comodoAtributo.id+'-'+comodoAtributoVariacao.id)}">
                                    <p [innerHtml]="comodoAtributoVariacao.descricao"></p>
                                 </div>
                              </div>
                              <div class="clear-button">
                                 <a href="javascript:void(0)" (click)="openVariation('c-'+comodo.id+'-'+comodoAtributo.id)">Limpar</a>
                              </div>
                           </div>
                        </div>
                     </accordion-group>
                     <accordion-group [isOpen]="false" heading="Complementares" class="last complementaries" (click)="accordionOptionClick('complementares')">
                        <div class="additional-attributes">
                           <div placement="left" class="option">
                              <div class="name">
                                 <strong>Fechadura Biométrica</strong><br/>
                                 <small>Este item será entregue pela Halma Incorporadora, sem custos adicionais.</small>
                              </div>
                              <div class="value"><input type="checkbox" checked disabled /></div>
                           </div>
                           <div placement="left" class="option">
                              <div class="name">
                                 <strong>Forro de Gesso</strong><br/>
                                 <small>Este item será entregue pela Halma Incorporadora, sem custos adicionais.</small>
                              </div>
                              <div class="value"><input type="checkbox" checked disabled /></div>
                           </div>
                           <div placement="left" class="option">
                              <div class="name">
                                 <strong>Nicho no Box (60L X 30H)</strong><br/>
                                 <small>Este item será entregue pela Halma Incorporadora, sem custos adicionais.</small>
                              </div>
                              <div class="value"><input type="checkbox" checked disabled /></div>
                           </div>
                           <div class="option" *ngFor="let atributoAdicional of atributosAdicionais" [tooltip]="tooltipAtributoAdicional" placement="left">
                              <div class="name"><strong>{{atributoAdicional.nome}}</strong><br/><small [innerHtml]="atributoAdicional.descricao"></small></div>
                              <div class="value"><!-- + {{atributoAdicional.preco | currency: 'BRL': true}}--> <input (change)="checkAdditional($event, atributoAdicional)" class="checkbox" type="checkbox" [checked]="checkAtributoAdicionalSession(atributoAdicional.id)" [disabled]="!checkHabilitarAdicionaisMultiplasSelecoes(atributoAdicional)"></div>
                              <ng-template #tooltipAtributoAdicional>
                                 <img id="tool-tip" src="{{caminhoImg+atributoAdicional.imagem}}"/>
                              </ng-template>
                           </div>
                           <!--
                           <div class="additional-value">
                              <div class="val-additional">{{valorAdicional | currency: 'BRL': true}}</div>
                              <div class="desc-additional">Valor dos itens complementares:</div>
                           </div>
                           -->
                        </div>
                     </accordion-group>
                  </accordion>
               </div>
            </div>
         </div>
      </div>
   </div>


   <!--
   <div class="back-home desktop">
      <a [routerLink]="['/selecionar-apartamento']">&#8592;</a>
   </div>
   <div class="back-home mobile">
      <a [routerLink]="['/selecionar-apartamento']"><img alt='Seta' src='assets/images/arrow-left-black.png' /> Voltar para apartamentos</a>
   </div>
   <div class="total-value">
      <div class="button">
         <div class="desc-total">Valor total</div>
         <div class="val-total">{{valorTotal | currency: 'BRL': true}}</div>
      </div>
   </div>
   -->
   <div class="proceed bottom">
      <div class="button">
         <a (click)="salvarSelecao()">Prosseguir &#8594;</a>
      </div>
   </div>

</div>

<div class="page-configurator min-resolution">
   <div class="change-position">
         <img src="assets/images/select-screen-size.png" alt="Virar o Aparelho" />
         <p class="text">Por favor vire a sua tela para uma melhor experiência.</p>
   </div>
</div>